import React from "react";
import { object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import sortBy from "lodash/sortBy";

import Headline from "../../atoms/headline";
import AuthorDetails from "../../molecules/author-details";

import "./team.m.css";

const TeamRow = ({ collection = {}, authorList }) => {
  // Filter to show only staff members (with Designation and Home Programme)
  const staffMembers = (authorList || []).filter(author => {
    if (!author.metadata) return false;
    if (author.metadata.status === "Alumnus") return false;
    if (author.id === 647041) return false;

    const hasDesignation = author.metadata.Designation || author.metadata.designation;
    const hasHomeProgram = author.metadata["Home Programme"] || author.metadata.homeProgramme;

    return hasDesignation && hasHomeProgram;
  });

  const shuffledStaff = staffMembers.sort(() => 0.5 - Math.random());
  const displayedStaff = shuffledStaff.slice(0, 6);
  const sortedList = sortBy(displayedStaff, [author => author.name]);

  const children =
    sortedList && sortedList.map((author, index) => <AuthorDetails key={index} author={author} isDesignation={true} />);

  return (
    <div className="container">
      <div styleName="header-wrapper">
        <Headline headerLevel={2} headerType={2} text="TEAM" />
      </div>
      <div styleName="wrapper">{children}</div>
      <div styleName="load-more">
        <a className="default-link-button" href="/people">
          SHOW MORE
        </a>
      </div>
    </div>
  );
};

TeamRow.propTypes = {
  collection: object,
  authorList: array
};

const mapStateToProps = state => {
  return {
    authorList: get(state, ["peopleReducer"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(TeamRow);
